export const getUserPermissions = (menuName) => {
    const userDataString = sessionStorage.getItem("userData");
    const permissionsData = JSON.parse(sessionStorage.getItem('UserPermissions'));
    // console.log(permissionsData , 'permissionsDatapermissionsDatapermissionsDatapermissionsData')

    if (userDataString && permissionsData) {
        const userData = JSON.parse(userDataString);

        // console.log(permissionsData, 'permissions data getting from session in getUserPermissions utility', menuName);
        const menuPermissions = permissionsData.find(permission => permission.MenuName === menuName);

        if (menuPermissions) {
            // console.log(`Permissions for menu '${menuName}':`, menuPermissions);
            
            return {
                isRead: (userData.RoleId === 1 || menuPermissions.Read === true) ? 'd-block' : 'd-none',
                isWrite: (userData.RoleId === 1 || menuPermissions.Write === true) ? 'd-block' : 'd-none',
                isDelete: (userData.RoleId === 1 || menuPermissions.Delete === true) ? 'd-block' : 'd-none',
                isExport: (userData.RoleId === 1 || menuPermissions.Export === true) ? 'd-block' : 'd-none',
            };
        } else {
            console.log(`${menuName} permissions not found.`);
            return {
                isRead: 'd-none',
                isWrite: 'd-none',
                isDelete: 'd-none',
                isExport: 'd-none',
            };
        }
    } else {
        console.log("User data or permissions not found in sessionStorage");
        return {
            isRead: 'd-none',
            isWrite: 'd-none',
            isDelete: 'd-none',
            isExport: 'd-none',
        };
    }
};
